// src/pages/components/TabelaMaquinas.jsx

import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress, Grid, Icon } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import DefaultImage from '../assets/Img/produto_default.png';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';

export default function CardsErrosImpressao({ erros, onResolve, loadingState }) {
    const { carregando, deletingId } = loadingState;

    if (carregando === 'fetching' || carregando === 'searching') {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit" /></Box>
    }

    if (erros.length === 0) {
        return <Box sx={{ textAlign: 'center', p: 5 }}>Nenhum erro de impressão encontrado.</Box>
    }

    return (
        <Grid container spacing={3} alignItems="stretch">
            {erros.map((prod, index) => (
                <Grid item size={{ sx: 1, sm: 6, md: 4, lg: 4, xl: 1, xs: 12 }} key={index}>
                    <Card
                        sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            borderRadius: 3,
                            boxShadow: 4,
                            transition: "0.3s",
                            "&:hover": {
                                boxShadow: 8,
                                transform: "translateY(-5px)",
                            },
                        }}
                    >
                        <CardContent>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                gutterBottom
                                color="primary"
                            >
                                {prod.nm_maquina}
                            </Typography>

                            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                                Operador: <b>{prod.operador}</b>
                            </Typography>

                            <Typography variant="body1" sx={{ mt: 1 }}>
                                {prod.desc_erro}
                            </Typography>
                        </CardContent>

                        <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                            <Button
                                onClick={() => onResolve(prod.id)}
                                size="large"
                                variant="outlined"
                                disabled={carregando === 'dell' ? true : false}
                                endIcon={carregando === 'dell' && deletingId === prod.id ? <CircularProgress color="inherit" size={17} /> : <DoneOutlineIcon />}
                                sx={{ borderRadius: 2, px: 3 }}
                            >
                                {carregando === 'dell' && deletingId === prod.id ? 'Aguarde' : 'Resolver'}
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            ))}
        </Grid>

    );
}